import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { UserIcon, PhoneIcon, MapPinIcon, CalendarIcon, ClockIcon } from 'lucide-react';
export function Hero() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    pickupAddress: '',
    dropOffAddress: '',
    transportationType: '',
    appointmentDate: '',
    appointmentTime: '',
    notes: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you! We will contact you shortly to confirm your booking.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="hero" className="relative min-h-[600px] lg:min-h-[700px] flex items-center" data-id="element-123">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/325iD7q5Sh6DuXZwvHnKRJ/car.png)'
    }} data-id="element-124">
        <div className="absolute inset-0 bg-[#0B1F3A] bg-opacity-85" data-id="element-125"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-16 w-full" data-id="element-126">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-127">
          {/* Left Side - Headline & CTAs */}
          <div className="text-white" data-id="element-128">
            <div className="inline-block px-4 py-2 bg-[#E63946] rounded-full text-sm font-semibold mb-6" data-id="element-129">
              The Perfect Ride Awaits
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-130">
              Safe, Reliable & Compassionate{' '}
              <span className="text-[#E63946]" data-id="element-131">Medical Transportation</span>
            </h1>
            <p className="text-lg md:text-xl mb-8 text-gray-200" data-id="element-132">
              Safe, comfortable, and on-time non-emergency medical
              transportation (NEMT) for doctor visits, dialysis, therapy
              sessions, and hospital transfers in Upper Marlboro and surrounding
              areas.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-133">
              <Button variant="primary" size="lg" onClick={() => document.getElementById('booking-form')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-134">
                Book Your Ride
              </Button>
              <Button variant="outline" size="lg" onClick={() => window.location.href = 'tel:2405653357'} data-id="element-135">
                Call Now
              </Button>
            </div>
          </div>

          {/* Right Side - Booking Form */}
          <div id="booking-form" className="bg-white rounded-lg shadow-2xl p-6 lg:p-8" data-id="element-136">
            <h2 className="text-2xl font-bold text-[#0B1F3A] mb-6" data-id="element-137">
              Book a Medical Ride Now
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-138">
              <Input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} icon={<UserIcon className="h-5 w-5" data-id="element-140" />} required data-id="element-139" />
              <Input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} icon={<PhoneIcon className="h-5 w-5" data-id="element-142" />} required data-id="element-141" />
              <Input type="text" name="pickupAddress" placeholder="Pickup Address" value={formData.pickupAddress} onChange={handleChange} icon={<MapPinIcon className="h-5 w-5" data-id="element-144" />} required data-id="element-143" />
              <Input type="text" name="dropOffAddress" placeholder="Drop-Off Address" value={formData.dropOffAddress} onChange={handleChange} icon={<MapPinIcon className="h-5 w-5" data-id="element-146" />} required data-id="element-145" />
              <div className="relative" data-id="element-147">
                <select name="transportationType" value={formData.transportationType} onChange={handleChange} required className="w-full rounded-md border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#E63946] focus:border-transparent transition-all appearance-none bg-white" data-id="element-148">
                  <option value="" data-id="element-149">Select Transportation Type</option>
                  <option value="nemt" data-id="element-150">Non-Emergency Medical Transport</option>
                  <option value="wheelchair" data-id="element-151">Wheelchair Transport</option>
                  <option value="stretcher" data-id="element-152">Stretcher Transport</option>
                  <option value="ambulatory" data-id="element-153">Ambulatory Transport</option>
                </select>
              </div>
              <Input type="date" name="appointmentDate" placeholder="Appointment Date" value={formData.appointmentDate} onChange={handleChange} icon={<CalendarIcon className="h-5 w-5" data-id="element-155" />} required data-id="element-154" />
              <Input type="time" name="appointmentTime" placeholder="Appointment Time" value={formData.appointmentTime} onChange={handleChange} icon={<ClockIcon className="h-5 w-5" data-id="element-157" />} required data-id="element-156" />
              <Textarea name="notes" placeholder="Additional Notes (Optional)" value={formData.notes} onChange={handleChange} rows={3} data-id="element-158" />
              <Button type="submit" variant="primary" className="w-full" size="lg" data-id="element-159">
                Get Instant Confirmation
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}